import { trackRouteChange } from 'pb-tracking';

/**
 * Reports client-side navigations to this app's own `/api/pv`, which is the
 * only thing the server cannot see for itself: Nitro renders the shell once,
 * and every route after that is the router's business.
 *
 * A surface with tracking switched off registers nothing — no route hook, and
 * so not one request. The switch is the only part of the config that is public;
 * the endpoint and key stay server-side, where the browser never sees them.
 */
export default defineNuxtPlugin(() => {
  if (!useRuntimeConfig().public.tracking.enabled) return;

  useRouter().afterEach(trackRouteChange);
});
